module.exports = __webpack_public_path__ + "static/vf_wcardigan_core.75e6f3b4.svg";